import { render, staticRenderFns } from "./MerchantSettings.vue?vue&type=template&id=11e2cd1c&scoped=true"
import script from "./MerchantSettings.vue?vue&type=script&lang=js"
export * from "./MerchantSettings.vue?vue&type=script&lang=js"
import style0 from "./MerchantSettings.vue?vue&type=style&index=0&id=11e2cd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2cd1c",
  null
  
)

export default component.exports